import React, { useEffect, useState } from "react";
import Dialog from "../../../base/ui/components/web/Dialog";
// @ts-ignore
import DeviceRoomInfo from "./DeviceRoomInfo";
// @ts-ignore
import { useDispatch } from "react-redux";
// @ts-ignore
import { setIsEventRequestingLoader, setIsNatType, setPrejoinConnectionStamp, setPrejoinDeviceConnectTime, setPrejoinDeviceMessages, setPrejoinDevicePingCalculate, setPrejoinDeviceStepRunning, setPrejoinScreenUserRoute, setPrejoinSubscriptionUI, setShowDevicePreConnection } from "../../redux/tool-webjam-v3/actions";
// @ts-ignore
import { makeHostRoomStatus } from "./HelperComponent";
// @ts-ignore
import { sendData } from "../../../webjam/websocket";
// @ts-ignore
import { setDeviceContainerStatus, setEnableWebjamModal, setJoinRoomWithoutDevice, setPrejoinScreenDetail } from "../../redux/tool-webjam-v2/actions";
// @ts-ignore
import { hideApiLoader, setRoomorIpAddress, showApiLoader } from "../../redux/tool-webjam/actions";
// @ts-ignore
import { _ValidateIPaddress, getBaseConfig, getStore, prejoinDeviceCalculateFlag } from "../../Utils";
import { ct } from "../../constant-Utils";
// @ts-ignore
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V3 } from "../../constant";
// @ts-ignore
import { getNatTypeApi } from "../../welcome-dashboard/Request.d";
// @ts-ignore
import { CURRENT_ROOM_NAME } from "../../../webjam/constant";
const DevicePreConnection = (props) => {
    const dispatch = useDispatch();
    const { uniqueId, prejoinScreenDetail, protocolId, usersData, joinRoomWithoutDevice } = props;
    const [connectStamp, setConnectStamp] = useState(0);
    const [hitCount, setHitCount] = useState(0);
    const flushPrevious = () => {
        dispatch(setPrejoinDeviceMessages({
            show: false,
            messages: {}
        }, "device init reset"));
        dispatch(setPrejoinSubscriptionUI({
            show_basic: false,
            basic_checking: "",
            show_premium: false
        }));
        dispatch(setPrejoinDeviceStepRunning(false, ""));
        dispatch(setPrejoinDevicePingCalculate(prejoinDeviceCalculateFlag.DEFAULT));
        dispatch(setPrejoinDeviceConnectTime(0));
    };
    useEffect(() => {
        var cssId = 'device-connect';
        let hasCss = document.getElementById(cssId);
        if (!hasCss) {
            var head = document.getElementsByTagName('head')[0];
            var link = document.createElement('style');
            link.id = cssId;
            link.innerHTML = `.device-room-info-content-lists span {
                        color: var(--theme-default-text-color) !important;
                        font-weight: normal;
                        transition: all ease 4ms;
                        transition: all .3s ease;
                        -webkit-transition: all .3s ease;
                        transition: width 1s, height 1s;
                        -webkit-transition: max-height 1s;
                        -moz-transition: max-height 1s;
                        -ms-transition: max-height 1s;
                        -o-transition: max-height 1s;
                        transition: max-height 1s;

                     }
                     .loading-content svg path {
                        fill : var(--theme-primary-color)
                    }
                     `;
            head.appendChild(link);
        }
        dispatch(setPrejoinScreenUserRoute(""));
        dispatch(setJoinRoomWithoutDevice(false));
        flushPrevious();
        let time = Math.round(new Date().getTime() / 1000);
        setConnectStamp(time);
        dispatch(setPrejoinConnectionStamp(time));
        return () => {
            document.getElementById(cssId)?.remove();
            flushPrevious();
            setConnectStamp(0);
            dispatch(setPrejoinConnectionStamp(0));
        };
    }, []);
    const unpairDevice = (isCancel = false) => {
        dispatch(showApiLoader({
            loaderAdditionalDetail: !isCancel ? ct("Translate.messages.deviceConnecting") : null,
            type: "unpair-device-1"
        }));
        if (isCancel) {
            setTimeout(() => {
                dispatch(hideApiLoader());
            }, 20000);
        }
        if (!isCancel && usersData) {
            for (var i = 1; i <= 4; i++) {
                (function (index) {
                    setTimeout(function () {
                        dispatch(showApiLoader({
                            loaderAdditionalDetail: ct("Translate.messages.deviceConnecting"),
                            type: "unpair-device-" + i
                        }));
                    }, i * 1000);
                })(i);
            }
            dispatch(setIsEventRequestingLoader('device-disconnect'));
            setTimeout(function () {
                dispatch(setIsEventRequestingLoader(''));
            }, 20000);
        }
        const data = {
            action: {
                uniqueID: uniqueId,
                ipAddress: prejoinScreenDetail.roomname,
                protocolId: protocolId,
            },
            content: 'unpair-device',
            isBroadcast: true,
            sender: 'mobile',
            scope: "conference-joined-unpair v2"
        };
        sendData(data);
    };
    const handleSubmit = () => {
        const { roomorIpAddress } = getStore(FEATURE_CUSTOM_REDUX);
        let willConnect = false;
        let selfRoomUrl = !_ValidateIPaddress(CURRENT_ROOM_NAME);
        let selfRoomBox = !_ValidateIPaddress(roomorIpAddress);
        dispatch(setDeviceContainerStatus("closeWebjamMixer", "pre-meeting submit"));
        if (getBaseConfig("checkNatType") && selfRoomUrl && selfRoomBox) {
            console.log("NAT type flow will work =>");
        }
        else {
            unpairDevice();
        }
        dispatch(setShowDevicePreConnection(false));
        dispatch(setEnableWebjamModal(false));
        if (getBaseConfig("checkNatType") && selfRoomUrl && selfRoomBox) {
            setTimeout(async function () {
                try {
                    let getNatType = await getNatTypeApi({
                        uniqueID: uniqueId,
                        roomName: CURRENT_ROOM_NAME,
                        location: window.location.origin,
                    });
                    if (getNatType.status == 1) {
                        let natType = getNatType.data.type;
                        if (natType == 1) {
                            unpairDevice();
                            willConnect = true;
                        }
                        else if (natType == 2) {
                            unpairDevice();
                            dispatch(setRoomorIpAddress(getNatType.data.thirdParty));
                            let now_time = Math.round(new Date().getTime() / 1000);
                            sessionStorage.setItem("dv_cnf_tm", JSON.stringify({
                                time: now_time,
                                id: uniqueId
                            }));
                            flushPrevious();
                        }
                        else if (natType == 3) {
                            dispatch(setIsNatType({
                                type3: true,
                                type3Data: {
                                    uniqueID: uniqueId,
                                    ipAddress: prejoinScreenDetail.roomname,
                                    protocolId: protocolId,
                                }
                            }));
                            dispatch(showApiLoader({
                                loaderAdditionalDetail: ct("rta-trmc.natType.natTypePermissionLoader"),
                            }));
                        }
                    }
                }
                catch (e) {
                    console.log("checkNatType error =>", e);
                }
            }, 10);
        }
        else {
            willConnect = true;
        }
        if (willConnect) {
            setTimeout(async function () {
                await makeHostRoomStatus();
            }, 10);
            for (var i = 1; i <= 8; i++) {
                (function (index) {
                    setTimeout(async function () {
                        await makeHostRoomStatus();
                    }, i * 1000);
                })(i);
            }
            setTimeout(async function () {
                await makeHostRoomStatus();
            }, 10000);
            let now_time = Math.round(new Date().getTime() / 1000);
            sessionStorage.setItem("dv_cnf_tm", JSON.stringify({
                time: now_time,
                id: uniqueId
            }));
            flushPrevious();
        }
    };
    const handleCancel = () => {
        unpairDevice();
        dispatch(setDeviceContainerStatus("closeWebjamMixer", "pre-meeting cancel"));
        dispatch(setEnableWebjamModal(false));
        dispatch(setPrejoinDeviceConnectTime(0));
        dispatch(setPrejoinDeviceStepRunning(false));
        dispatch(setPrejoinScreenDetail({
            isSet: false,
            roomname: "",
            uniqueId: "",
            scope: "preconnection user cancel"
        }));
        dispatch(setShowDevicePreConnection(false));
        flushPrevious();
    };
    let { prejoinDeviceMessages } = getStore(FEATURE_CUSTOM_REDUX_V3);
    let showConnectWithBox = false;
    if (prejoinDeviceMessages.messages?.CHECK_SUBSCRIPTION?.success && joinRoomWithoutDevice && usersData) {
        showConnectWithBox = true;
    }
    if (getBaseConfig("prejoinAutoConnect") && showConnectWithBox) {
        dispatch(showApiLoader());
        if (hitCount == 0) {
            setHitCount(1);
            handleSubmit();
        }
    }
    return (React.createElement(Dialog, { titleKey: ct("Translate.typography.preMeetingInConferenceTitle"), ok: {
            hidden: getBaseConfig("prejoinAutoConnect") ? true : !showConnectWithBox,
            translationKey: ct("Translate.buttonTitle.connectWithBox")
        }, onSubmit: () => {
            handleSubmit();
        }, disableBackdropClose: true, rtaClassName: 'device-pre-connection-container', onCancel: () => {
            handleCancel();
        }, hideCloseButton: true },
        React.createElement(DeviceRoomInfo, { hideVideo: true, hideAudio: true, hideInit: true, joinWithConference: true, connectStamp: connectStamp })));
};
export default DevicePreConnection;
